import { Box } from '@moonpig/launchpad-components'
import { colorValue } from '@moonpig/launchpad-theme'
import { styled } from '@moonpig/launchpad-utils'
import React, { FC, useCallback, useLayoutEffect } from 'react'
import { system as s } from '@moonpig/launchpad-system'

const StyledArrow = styled(Box)<{ leftPosition: number }>`
  position: absolute;
  top: -16px;
  width: 0;
  height: 0;
  pointer-events: none;

  ${({ leftPosition }) =>
    s({
      left: `calc(${leftPosition}px + 4px)`,
    })}

  &::after {
    content: '';
    display: block;
    width: 0;
    height: 0;
    margin: auto;
    border-left: 16px solid transparent;
    border-right: 16px solid transparent;
    border-bottom: 16px solid ${colorValue('colorBackground03')};
  }
`

export const PanelArrow: FC<{
  panelRef: React.RefObject<HTMLDivElement>
  triggerProductRef: React.RefObject<HTMLButtonElement>
}> = ({ panelRef, triggerProductRef }) => {
  const [leftPosition, setLeftPosition] = React.useState(0)
  const updatePanelOrigin = useCallback(() => {
    if (!triggerProductRef.current || !panelRef.current) {
      return
    }

    const triggerLeft = triggerProductRef.current.getBoundingClientRect().left
    const panelLeft = panelRef.current.getBoundingClientRect().left
    setLeftPosition(triggerLeft - panelLeft)
  }, [panelRef, triggerProductRef])

  useLayoutEffect(() => {
    updatePanelOrigin()
  }, [updatePanelOrigin])

  return <StyledArrow leftPosition={leftPosition} />
}
